import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './features/login/login.component';
import { LoginRoutingModule } from './features/login/login-routing.module';
import { RegisterComponent } from './features/register/register.component';
import { RegisterRoutingModule } from './features/register/register-routing.module';
import { PanelComponent } from './features/panel/panel.component';
import { PanelRoutingModule } from './features/panel/panel-routing.module';
import { ImageEditorComponent } from './features/image-editor/image-editor.component';
import { ImageEditorRoutingModule } from './features/image-editor/image-editor-routing.module';
import { ToastUiImageEditorModule } from 'ngx-tui-image-editor';
import { AdminDashboardComponent } from './features/admin-dashboard/admin-dashboard.component';
import { AdminDashboardRoutingModule } from './features/admin-dashboard/admin-dashboard-routing.module';
import { DataTablesModule } from 'angular-datatables';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { DeleteTemplateModalComponent } from './components/modals/delete-template-modal/delete-template-modal.component';
import { DeleteCategoryModalComponent } from './components/modals/delete-category-modal/delete-category-modal.component';
import { EditCategoryModalComponent } from './components/modals/edit-category-modal/edit-category-modal.component';
import { UsersRoutingModule } from './features/users/users-routing.module';
import { UsersComponent } from './features/users/users.component';
import { EditUserModalComponent } from './components/modals/edit-user-modal/edit-user-modal.component';
import { DeleteUserModalComponent } from './components/modals/delete-user-modal/delete-user-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    PanelComponent,
    ImageEditorComponent,
    AdminDashboardComponent,
    DeleteTemplateModalComponent,
    DeleteCategoryModalComponent,
    EditCategoryModalComponent,
    UsersComponent,
    EditUserModalComponent,
    DeleteUserModalComponent,
  ],
  imports: [
    BrowserModule,
    NgbModule,
    FormsModule,
    HttpClientModule,
    AppRoutingModule,
    LoginRoutingModule,
    RegisterRoutingModule,
    PanelRoutingModule,
    ImageEditorRoutingModule,
    ToastUiImageEditorModule,
    AdminDashboardRoutingModule,
    DataTablesModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    UsersRoutingModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
